import * as React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import { changeBranding, changeCoverImage, changePostcardImageFront, changePostcardImageBack, changePosterImageBackground, createDocument, setupWizard } from '../../actions/actions';
import { IBranding, ICoverImage, IUserData, IPostcardImage, IPosterImage} from '../../infrastructure/interfaces';
import { ProductType, productType } from '../../infrastructure/ProductType';
import { avaliableDocTypes } from '../../components/App/config';


const bulletinLogo = require('./images/Bulletin.svg');
const brochureLogo = require('./images/Brochure.svg');
const catalogLogo = require('./images/Catalog.svg');
const postcardLogo = require('./images/Postcard.svg');
const posterLogo = require('./images/Poster.svg');

export interface LandingPageProps {
  userData: IUserData;
  createDocument(type: ProductType, userID: string): void;
  setupWizard(type: ProductType): void;
  brandings: IBranding[];
  coverImages: ICoverImage[];
  postcardImages: IPostcardImage[];
  posterImages: IPosterImage[];
  changeBranding(brand: IBranding): void;
  changeCoverImage(image: ICoverImage): void;
  changePostcardImageFront(postcardImageFront: IPostcardImage): void;
  changePostcardImageBack(postcardImageBack: IPostcardImage): void;
  changePosterImageBackground(posterImageBackground: IPosterImage): void;
}

const mapStateToProps = (state: any) => {
  return {
    userData: state.user.data,
    brandings: state.wizard.brandings,
    coverImages: state.wizard.coverImages,
    postcardImages: state.wizard.postcardImages,
    posterImages: state.wizard.posterImages,
  };
};

const mapDispatchToProps = (dispatch: any): any => {
  return {
    createDocument: (type: ProductType, userID: string): void => {
      dispatch(createDocument(type, userID));
    },
    setupWizard: (type: ProductType): void => {
      dispatch(setupWizard(type));
    },
    changeBranding: (brand: IBranding): void => {
      dispatch(changeBranding(brand));
    },
    changeCoverImage: (image: ICoverImage): void => {
      dispatch(changeCoverImage(image));
    },
    changePostcardImageFront: (postcardImageFront: IPostcardImage): void => {
      dispatch(changePostcardImageFront(postcardImageFront));
    },
    changePostcardImageBack: (postcardImageBack: IPostcardImage): void => {
      dispatch(changePostcardImageBack(postcardImageBack));
    },
    changePosterImageBackground: (posterImageBackground: IPosterImage): void => {
      dispatch(changePosterImageBackground(posterImageBackground));
    }
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class LandingPage extends React.Component<LandingPageProps> {

  click(type: ProductType, history: any) {

    this.props.createDocument(type, this.props.userData.id);
    this.props.setupWizard(type);

    // by default on brochure selected loveland;
    const brand = this.props.brandings.find(brand => brand.title === 'Loveland');
    const image = this.props.coverImages.find(image => image.id === 1);
    const postcardImageFront = this.props.postcardImages.find(postcardImage  => postcardImage.side === "Front");
    const postcardImageBack = this.props.postcardImages.find(postcardImage  => postcardImage.side === "Back");
    const posterImageBackground = this.props.posterImages[0]
    if (brand) {
      this.props.changeBranding(brand);
    }
    if (image) {
      this.props.changeCoverImage(image);
    }
    if (postcardImageFront){
      this.props.changePostcardImageFront(postcardImageFront)
    }
    if (postcardImageBack){
      this.props.changePostcardImageBack(postcardImageBack)
    }
    if (posterImageBackground){
      this.props.changePosterImageBackground(posterImageBackground)
    }

    history.push('/Wizard');
  }

  renderPortal(title: string, isEnabled: boolean, type: any, image?: string, description?: string): any {
    return (
      <Route
        render={({ history }) => (
          <div>
            <button
              disabled={!isEnabled}
              className="portal"
              onClick={() => this.click(type, history)}>

              <div className="portal-wrapper">
                <div className="portal-logo">
                  <img src={image} />
                </div>
                <div className="portal-title">
                  <span>{title}</span>
                  <div>{description}</div>
                </div>
              </div>
            </button>
          </div>)
        } />
    );
  }

  render() {
    return (
      <div className="lp-wrapper">
        <div className="lp-header">
          <div className="lp-headline">Choose the Guide You Want to Build</div>
          <div className="optionText">Click one option below</div>
        </div>
        <div className="lp-body">
          {this.renderPortal('Bulletin', avaliableDocTypes.bulletin, productType.Bulletin, bulletinLogo, 'Single Product')}
          {this.renderPortal('Quad Fold', avaliableDocTypes.brochure, productType.Brochure, brochureLogo, 'Up to 8 Products')}
          {this.renderPortal('Catalog', avaliableDocTypes.catalog, productType.Catalog, catalogLogo)}
          {this.renderPortal('Postcard', avaliableDocTypes.postcard, productType.Postcard, postcardLogo, 'Up to 4 Products')}
          {this.renderPortal('Poster', avaliableDocTypes.poster, productType.Poster, posterLogo, 'Up to 10 Products')}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LandingPage/LandingPage.tsx